import styles from './youtube-embed.module.less';

const getYouTubeVideoIdFromUrl = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : undefined;
};

const objectToQueryString = (obj) => {
    const params = Object.entries(obj).map(([k, v]) => `${k}=${v}`);
    return params.join('&');
};

export default function YoutubeEmbed({
    title,
    url,
    margins = false,
    autoplay = false,
    loop = false,
    controls = true,
    mute = false,
    aspectRatio = '16 / 9',
}) {
    if (!url) {
        return <></>;
    }
    const queryParams = {
        playsinline: '1',
        autoplay: autoplay ? '1' : '0',
        mute: autoplay || mute ? '1' : '0',
        controls: controls ? '1' : '0',
        loop: loop ? '1' : '0',
    };
    const youtubeId = getYouTubeVideoIdFromUrl(url);
    return (
        <div className={[styles.youtubeEmbedContainer, margins ? styles.youtubeMargins : undefined].join(' ')}>
            <iframe
                src={`https://www.youtube.com/embed/${youtubeId}?${objectToQueryString(queryParams)}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={title || 'Youtube video'}
                style={{ aspectRatio }}
            />
        </div>
    );
}
